import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api/apiClient';
import '../css/MobileEntry.css';
// import kkko from '../assets/icons/logo.png';
import { AppContext } from '../context/AppContext';
import { toast } from 'react-toastify';
import logo from "../assets/icons/dpboss.png";

const MobileEntry = () => {
  const [phone, setPhone] = useState('');
  const navigate = useNavigate();
  const { setMobileNo } = useContext(AppContext);

  const handleNext = async () => {
    if (phone.length !== 10) {
      toast.warn('Please enter a valid 10-digit phone number.');
      return;
    }

    try {
      const res = await apiClient.post('/check-mobile', {
        mobileNo: phone,
      });

      localStorage.removeItem('accessToken');
      localStorage.removeItem('registerId');
      localStorage.removeItem('userProfile');
      if (setMobileNo) setMobileNo(phone);
      localStorage.setItem('mobileNo', phone);
      localStorage.setItem('lastLoginMobileNo', phone);

      if (res?.data?.status === true) {
        navigate('/login-with-mpin', { replace: true });
      } else {
        navigate('/create-account', { replace: true });
      }
    } catch (error) {
      console.error('Mobile check failed:', error?.response || error);
      toast.error('An error occurred. Please try again.');
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <div className="top-header">
        Create Your Account
      </div>

      <div className='hul'>
        <div className="ms-phoneGlyph">
          <img src={logo} alt="Phone" className="ms-phoneImg" />
        </div>

        <div className="ms-inputRow">
          <div className="ms-inputIcon" aria-hidden="true">
            <svg width="38" height="38" viewBox="0 0 24 24">
              <rect x="6" y="3" width="12" height="18" rx="2" fill="none" stroke="#666" strokeWidth="1.6" />
              <rect x="9" y="5.5" width="6" height="1.6" rx="0.8" fill="#666" />
              <rect x="9" y="17.6" width="6" height="2.2" rx="1.1" fill="#666" />
            </svg>
          </div>

          <input
            id="mobile"
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            className="ms-input"
            placeholder="Enter Mobile Number"
            value={phone}
            onChange={(e) =>
              setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))
            }
            maxLength={10}
            autoFocus
          />

          <span className="ms-underline" />
        </div>

        <button className="ms-btn" type="button" onClick={handleNext}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default MobileEntry;
